"use client";

import Link from "next/link";
import { ReadonlyURLSearchParams, usePathname, useSearchParams } from "next/navigation";
import { MouseEventHandler, ReactNode } from "react";

export type AuthLinkParams = {
  children: ReactNode;
  className: string;
  onClick?: MouseEventHandler;
};

export function generateAuthLinkUrl(
  pathname: string,
  query: ReadonlyURLSearchParams | undefined,
  mode: "signin" | "signup",
) {
  let from: string | null;
  if (pathname === "/auth/signin" || pathname === "/auth/signup") {
    //ログインページの場合はfromのパラメター引き継ぐ
    from = query ? query.get("from") : "";
  } else {
    //それ以外のページの場合は元のページに戻る
    const queryString = query ? query.toString() : "";
    from = pathname + (queryString ? "?" + queryString : "");
  }
  return `/auth/${mode}` + (from ? `?from=${encodeURIComponent(from)}` : "");
}

export function AuthLink({
  children,
  className,
  mode,
  onClick,
}: AuthLinkParams & { mode: "signin" | "signup" }) {
  const pathname = usePathname();
  const query = useSearchParams();

  return (
    <Link className={className} href={generateAuthLinkUrl(pathname, query, mode)} onClick={onClick}>
      {children}
    </Link>
  );
}
